export default {
  id: "locations",
  name: "Locations",
  shortName: "Locations",
  description: "Restaurant locations & districts",
  icon: "mapPin",
  color: "#059669",
  roles: ["super_admin", "admin", "corporate"],
  css: "styles/apps/locations.css",
  nav: [
    { id: "directory", label: "Directory" },
    { id: "districts", label: "Ops Districts" },
    { id: "lsm-districts", label: "LSM Territories" },
  ],
  defaultView: "directory",
};
